interface FooterProps {
  onAdminPress?: () => void;
  onAdminRelease?: () => void;
}

export default function Footer({ onAdminPress, onAdminRelease }: FooterProps) {
  return (
    <footer className="bg-blue-600 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div className="md:col-span-2">
            <h3 
              className="text-xl sm:text-2xl font-bold mb-4"
              onMouseDown={onAdminPress}
              onMouseUp={onAdminRelease}
              onMouseLeave={onAdminRelease}
              onTouchStart={onAdminPress}
              onTouchEnd={onAdminRelease}
            >
              株式会社トラスト
            </h3>
            <div className="space-y-3 text-white/90">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                <a href="tel:052-887-6243" className="text-sm sm:text-base hover:text-white transition-colors cursor-pointer">
                  052-887-6243
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </div>
                <span className="text-sm sm:text-base">年中無休9:00〜19:00</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span className="text-sm sm:text-base">名古屋市緑区曽根2-146-2</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm text-white/80">
          <p>&copy; 2019 株式会社トラスト. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
